// key_helper.js
// DEFAULT SETTINGS FOR FORMAT
export const DEFAULT_SETTINGS = {
    DATE_FORMAT: 'dd-MM-yyyy',
    PAYLOAD_DATE_FORMAT: 'yyyy-MM-dd',
    DATE_TIME_FORMAT: 'yyyy-MM-dd HH:mm:ss',

};
export const STORAGE_KEYS = {
    AVFX_ADMIN_ACCESS_TOKEN: 'AVFX_ADMIN_ACCESS_TOKEN',
    AVFX_ADMIN_REMEMBER_ME: 'AVFX_ADMIN_REMEMBER_ME',
    USER_MANAGEMENT_TABLE: 'AVFX_USER_MANAGEMENT',
    AVFX_USER_COPIED_STRATEGY_TABLE: 'AVFX_USER_COPIED_STRATEGY',
    AVFX_USER_STRATEGY_TABLE: 'AVFX_USER_STRATGEY_TABLE',
    AVFX_COPIER_TRANSACTION_TABLE: 'AVFX_COPIER_TRANSACTION_TABLE',
    AVFX_STRATEGY_TABLE: 'AVFX_STRATEGY_TABLE',
    AVFX_STRATGEY_COPIER_TABLE: 'AVFX_STRATEGY_COPIER_TABLE',
    AVFX_STRATGEY_TRANSACTION_TABLE: 'AVFX_STRATEGY_TRANSACTION_TABLE',
    AVFX_OPEN_POSITION_TABLE: 'AVFX_OPEN_POSITION_TABLE',
    AVFX_PENDING_ORDER_TABLE: 'AVFX_PENDING_ORDER_TABLE',
    AVFX_CLOSE_ORDER_TABLE: 'AVFX_CLOSE_ORDER_TABLE'
}
export const SORT_ORDER = {
    ASCENDING: "ASC",
    DESCENDING: "DESC"
}
export const ROUTES = {
    LOGIN: '/login',
    DASHBOARD: '/dashboard',
    USER_MANAGEMENT: '/user-management',
    USER_DETAILS: (userId = ':user_id') => `/user-management/${userId}`,
    USER_STRATEGY_DETAILS: (userId = ':user_id', masterId = ':master_id') => `/user-management/${userId}/master-strategy/${masterId}`,
    USER_TRADE_DETAILS: (mt5Id = ':fx_login') => `/user-management/trade/${mt5Id}`,
    USER_COPIER_DETAILS: (childId = ':child_id') => `/user-management/copier/${childId}`,
    STRATEGY: '/master-strategy',
    STRATEGY_DETAILS: (masterId = ':master_id') => `/master-strategy/${masterId}`,
    STRATEGY_TRADE_DETAILS: (mt5Id = ':fx_login') => `/master-strategy/trade/${mt5Id}`,
    STRATEGY_COPIER_DETAILS: (childId = ':child_id') => `/master-strategy/copier/${childId}`,
    MAIL_CONFIG: '/mail-configs',
    NOT_FOUND: '/404'

};

export const USER_DETAILS_TAB = {
    COPIED_STRATEGY: 'Copied Strategy',
    MASTER_STRATEGY: 'Master Strategy',
    TRANSACTION: 'Transaction',
    EARNING: 'Earning'
}
export const STRATEGY_DETAILS_TAB = {
    COPIERS: 'Copiers',
    TRANSACTION: 'Transaction'
}
export const TRADE_TAB = {
    OPEN: 'Open Positions',
    PENDING: 'Pending Orders',
    CLOSED: 'Closed Orders'
}
export const TAB_UI_TYPE = {
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    TIME: 'TIME'
}
export const TRANSACTION_TYPE = {
    CREDIT: 'credit',
    DEBIT: 'debit'
}

// Strategy Charges Modes
export const STRATEGY_CHARGES_MODE = {
    PREPAID: 'PREPAID',
    PROFIT_SHARING: 'PROFITSHARING',
    FREE: 'FREE',
};
// child account status 
export const CHILD_ACCOUNT_STATUS = {
    EXPIRED: 'expired',
    ACTIVE: 'active',
    SL_HIT: "sl_hit",
    TGT_HIT: "tgt_hit",
    STOPPED: 'stopped'

}

export const ORDER_EXECUTION_TYPE = {
    [-1]: "DEPOSIT",
    [-2]: "WITHDRAW",
    0: 'BUY',
    1: 'SELL',
    2: 'BUY LIMIT',
    3: 'SELL LIMIT',
    4: 'BUY STOP',
    5: 'SELL STOP',
    6: 'BUY STOP LIMIT',
    7: 'SELL STOP LIMIT',
}
export const ORDER_STATE_TYPE = {
    [-1]: 'FAILED',
    0: 'STARTED',
    1: 'PLACED',
    2: 'CANCELED',
    3: 'PARTIAL',
    4: 'FILLED',
    5: 'REJECTED',
    6: 'EXPIRED',
    7: 'REQUEST ADD',
}
export const TOP_10_MASTER_FILTER = {
    ROI_PERCENTAGE: 'roi_percentage',
    WEEKLY_PROFIT_PERCENTAGE: 'weekly_profit_percentage',
    MONTHLY_PROFIT_PERCENTAGE: 'monthly_profit_percentage',
    THREE_MONTH_PROFIT_PERCENTAGE: 'three_month_profit_percentage',
    SIX_MONTH_PROFIT_PERCENTAGE: 'six_month_profit_percentage',
    YEARLY_PROFIT_PERCENTAGE: 'yearly_profit_percentage',
    TOTAL_AUM: 'total_aum',
    NO_OF_COPIERS: 'no_of_copiers'
}

export const EDIT_CONFIG_TYPE = {
    MASTER_BALANCE: 'MASTER_BALANCE',
    MASTER_PLATFORM_FEES: 'MASTER_PLATFORM_FEES'
}
export const getChargeMapping = (input) => {
    const map = {
        [STRATEGY_CHARGES_MODE.PREPAID]: 1,
        [STRATEGY_CHARGES_MODE.PROFIT_SHARING]: 2,
        [STRATEGY_CHARGES_MODE.FREE]: 3,
        1: STRATEGY_CHARGES_MODE.PREPAID,
        2: STRATEGY_CHARGES_MODE.PROFIT_SHARING,
        3: STRATEGY_CHARGES_MODE.FREE,
    };
    return map[input] || null;
};
export const TABS = {
    USER_DETAILS_TABS: [
        { name: USER_DETAILS_TAB.COPIED_STRATEGY, value: USER_DETAILS_TAB.COPIED_STRATEGY },
        { name: USER_DETAILS_TAB.MASTER_STRATEGY, value: USER_DETAILS_TAB.MASTER_STRATEGY },
        // { name: USER_DETAILS_TAB.TRANSACTION, value: USER_DETAILS_TAB.TRANSACTION },
        // { name: USER_DETAILS_TAB.EARNING, value: USER_DETAILS_TAB.EARNING }

    ],
    STRATEGY_DETAILS_TABS: [
        { name: STRATEGY_DETAILS_TAB.COPIERS, value: STRATEGY_DETAILS_TAB.COPIERS },
        { name: STRATEGY_DETAILS_TAB.TRANSACTION, value: STRATEGY_DETAILS_TAB.TRANSACTION },

    ],
    TRADE_TABS:
        [{ name: TRADE_TAB.OPEN, value: TRADE_TAB.OPEN },
        { name: TRADE_TAB.PENDING, value: TRADE_TAB.PENDING },
        { name: TRADE_TAB.CLOSED, value: TRADE_TAB.CLOSED },
        ]
}
export const DROPDOWN_OPTIONS = {
    YES_NO_OPTION: [
        { value: true, label: 'Yes' },
        { value: false, label: 'No' }
    ],
    CHARGE_OPTION: [
        { value: 2, label: STRATEGY_CHARGES_MODE.PROFIT_SHARING },
        { value: 3, label: STRATEGY_CHARGES_MODE.FREE }
    ],
    TRANSACTION_OPTION: [
        { value: TRANSACTION_TYPE.CREDIT, label: 'Credit' },
        { value: TRANSACTION_TYPE.DEBIT, label: 'Debit' }
    ],
    CHILD_ACCOUNT_STATUS_OPTION: [
        { value: CHILD_ACCOUNT_STATUS.ACTIVE, label: 'Active' },
        { value: CHILD_ACCOUNT_STATUS.EXPIRED, label: 'Expired' },
        { value: CHILD_ACCOUNT_STATUS.SL_HIT, label: 'SL Hit' },
        { value: CHILD_ACCOUNT_STATUS.TGT_HIT, label: 'Target Hit' },
        { value: CHILD_ACCOUNT_STATUS.STOPPED, label: 'Stopped' }
    ],
    TOP_10_MASTER_FILTER_OPTIONS: [
        { value: TOP_10_MASTER_FILTER.ROI_PERCENTAGE, label: 'Overall ROI (%)' },
        { value: TOP_10_MASTER_FILTER.WEEKLY_PROFIT_PERCENTAGE, label: 'Weekly ROI (%)' },
        { value: TOP_10_MASTER_FILTER.MONTHLY_PROFIT_PERCENTAGE, label: 'Monthly ROI (%)' },
        { value: TOP_10_MASTER_FILTER.THREE_MONTH_PROFIT_PERCENTAGE, label: '3M ROI (%)' },
        { value: TOP_10_MASTER_FILTER.SIX_MONTH_PROFIT_PERCENTAGE, label: '6M ROI (%)' },
        { value: TOP_10_MASTER_FILTER.YEARLY_PROFIT_PERCENTAGE, label: '1Y ROI (%)' },
        { value: TOP_10_MASTER_FILTER.TOTAL_AUM, label: 'Total AUM' },
        { value: TOP_10_MASTER_FILTER.NO_OF_COPIERS, label: 'No. of Copiers' },
    ]
}